export default __webpack_public_path__ + "static/release-campaign-eabba463ded34ce5b2e60e4aeefac59e.png";